/* tslint:disable:indent */
import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {NoticeTypesEnum} from '../../enum/notice-types.enum';
import {FormArray, FormGroup} from '@angular/forms';
import {EFormsSdkService} from '../../services/e-forms-sdk.service';
import {EformsSubjectService} from '../../services/eforms-subject.service';
import {Avis} from '../../../../../models/avis';
import {CanNavigateInStepperService} from '../../../../shared/services/can-navigate-in-stepper.service';
import {HttpService} from "../../../../shared/services/http.service";
import {Notice} from '../../model/notice';
import {StepperBuilderService} from "../../../../avisDePub/creer/services/stepper.builder.service";
import {first, take, takeUntil, pairwise, filter, defaultIfEmpty} from 'rxjs/operators';
import {EformsToolsService} from '../../services/e-forms-tools.service';
import {Annonce} from '../../../common/models/annonce';
import {TypeAnn} from '../../../common/models/type.ann';
import {FormsEnum} from '../../../../../models/enums/forms.enum';
import {ENoticeTypeXsd} from '../../../../../models/enums/enotice-type-xsd.enum';
import {ContractNotice} from '../../model/forms/contractnotice/ContractNotice';
import {PriorInformationNotice} from '../../model/forms/priorinformationnotice/PriorInformationNotice';
import {ContractAwardNotice} from '../../model/forms/contractawardnotice/ContractAwardNotice';
import {
  BusinessRegistrationInformationNotice
} from '../../model/forms/eforms_business_registration_information_notice/BusinessRegistrationInformationNotice';
import {TypeAdresseTEMPOST} from '../../../common/models/type.adresse.tempost';
import {ClasseProfit} from '../../../common/models/classe.profit';
import {AvisDataTransferService} from '../../../../shared/services/avis-data-transfer.service';
import {EformDataService} from "../../services/eform-data.service";
import {EformInfoService} from '../../services/eform-info.service';
import {EformPrefillService} from '../../services/eform-prefill.service';
import {FormulaireServiceService} from '../../../services/formulaire-service.service';
import {EFormsOrgService} from '../../services/e-forms-org.service';
import {SpinnerVisibilityService} from 'ng-http-loader';
import {FormInputFactory} from '../../../../shared/components/form-input/form-input/form.input.factory';
import {Section} from "../../model/section";
import {EformDuplicableEntityService} from "../../services/eform-duplicable-entity.service";
import {DuplicableElementPartialPathsEnum} from "../../enum/duplicable-element-partial-paths.enum";
import {EformConditionsService} from '../../services/eform-conditions.service';
import {EformConditionsV2Service} from "../../services/eform-conditions-v2.service";
import {EformDuplicableFieldsService} from "../../services/eform-duplicable-fields.service";
import {ProcurementProjectLotType} from "../../../../../models/eforms/commonaggregatecomponents_2/ProcurementProjectLotType";
import {DuplicableElementPathEnum} from "../../enum/duplicable-element-id-path.enum";

@Component({
  selector: 'app-e-forms-generator',
  templateUrl: './e-forms-generator.component.html',
  styleUrls: ['./e-forms-generator.component.css']
})
export class EFormsGeneratorComponent implements OnInit, OnDestroy {

  @Input() public noticeTypeBh: BehaviorSubject<any> = new BehaviorSubject(null);
  @Input() currentJson: BehaviorSubject<any> = new BehaviorSubject(null);

  title = 'eForms - POC';
  num = 1;
  public forms: Array<string> = [];
  public repeatablePath = '';
  @Input() indexPage: any;
  @Input() validationIndex: number;
  @Input() formGroup: FormGroup;
  @Input() linkForRouter: string;


  notice: Notice = null as Notice;
  noticeValue: any;
  duplicableSection: Section = null as Section;
  duplicableSectionClean: Section = null as Section;
  duplicableSectionValue: TypeAnn = null as TypeAnn;
  isDuplicableSectionReady: boolean = false;
  indexFirstDuplicableSection: number = null;
  private unsubscribeCurrentDuplicableSectionValue$ = new Subject<void>();
  private unsubscribe$ = new Subject<void>();
  private initialReloadingLockReleased = false; // Flag pour éviter les libérations multiples du verrou initial

  constructor(
    private httpClient: HttpService,
    private eformsSubjectService: EformsSubjectService,
    private canNavigateInStepperService: CanNavigateInStepperService,
    private stepperBuilderService: StepperBuilderService,
    private cd: ChangeDetectorRef,
    private eformsToolsService: EformsToolsService,
    private dataTransferService: AvisDataTransferService,
    private eformDataService: EformDataService,
    private eformInfoService: EformInfoService,
    private eformPrefillService: EformPrefillService,
    private formulaireService: FormulaireServiceService,
    private eFormsOrgService: EFormsOrgService,
    private spinner: SpinnerVisibilityService,
    private eformDuplicableEntityService: EformDuplicableEntityService,
    private eformConditionsService: EformConditionsService,
    private eformConditionsServiceV2: EformConditionsV2Service,
    private eformDuplicableFieldsService: EformDuplicableFieldsService,
  ) {
  }

  ngOnDestroy(): void {
    this.unsubscribeCurrentDuplicableSectionValue$.next();
    this.unsubscribeCurrentDuplicableSectionValue$.complete();
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.eformsSubjectService.setIdSchemeListSubject([]);
    this.eformInfoService.cleanService();
    this.eformPrefillService.isPrefillAvisLie = false;
    // ✅ FIX 2026-01-23: Réinitialiser le flag isLoadingAvisLie pour éviter qu'il ne reste bloqué
    this.eformConditionsServiceV2.setLoadingAvisLie(false);
    // ✅ FIX 2026-02-20: Réinitialiser le flag isLoadingPreference pour éviter qu'il ne reste bloqué
    this.eformConditionsServiceV2.setLoadingPreference(false);
    // ✅ FIX 2026-02-20: Réinitialiser tous les flags de conditions pour éviter qu'ils ne restent bloqués après duplication
    this.eformConditionsServiceV2.resetAllConditionFlags();
    this.eformPrefillService.tempNotice = null;
    this.eformPrefillService.noticeCompleted = new BehaviorSubject(null);
    this.stepperBuilderService.prefillDone = new BehaviorSubject(false);
    this.stepperBuilderService.clearAllStepFieldsOnErrors();
    this.stepperBuilderService.clearAllStepFieldsOnWarnings();
    this.eFormsOrgService.setNeedSecondOrganization(false);
    this.eformDuplicableEntityService.isEformDuplicableEntityReady.next(false);
    this.eformDuplicableEntityService.typeAnnForDuplicableSection.next(null);
    this.eformDuplicableEntityService.currentDuplicableSectionValue.next(null);
    this.eformDuplicableEntityService.duplicableSectionAvisLieIsCreated.next(false);
    this.eformDuplicableEntityService.duplicableSectionChargeEnded.next(false);
    this.eformDuplicableEntityService.missDuplicableSectionInit = false;
    this.eformDuplicableEntityService.organisationNotice = null;
    this.eformDuplicableEntityService.resultNotice = null;
    this.eformDuplicableEntityService.tenderNotice = null;
    this.eformDuplicableEntityService.settledContractNotice = null;
    this.eformDuplicableEntityService.tenderingPartyNotice = null;
    this.eformDuplicableEntityService.firstSaveIsEndedForAvisLie.next(false);
    this.eformDuplicableEntityService.isFirstSaveAndPreremp.next(false);
    this.eformDuplicableEntityService.needWaitEndUpdateForActiveControls = false;
    this.eformDuplicableEntityService.avisWithElementsDuplicable.next(null);
    this.eformDuplicableEntityService.isAvisWithAllDuplicablesElementsReady.next(false);
    this.eformDuplicableEntityService.isDataDuplicableEntityReady.next(false);
    this.eformDuplicableEntityService.isFormReady.next(false);
    this.eformConditionsService.clearExistingItemsList();
  }

  haveToHide(stepIndex: number) {
    //On affiche la section si la premiere partie de l'index de la page correspond à l'index de la liste qui contient
    // toutes les sections "dynamiques"
    let pageIndex = Number(this.indexPage?.toString().split('.')[0])
    if (this.eformDuplicableEntityService.getSectionDuplicableIndexes().length > 0 && this.eformDuplicableEntityService.getSectionDuplicableIndexes()[0] !== -1) {
      this.indexFirstDuplicableSection = this.eformDuplicableEntityService.getSectionDuplicableIndexes()[0];
    }
    if (this.indexFirstDuplicableSection && stepIndex >= this.indexFirstDuplicableSection) {
      stepIndex = stepIndex + this.eformDuplicableEntityService.getSectionDuplicableIndexes().length
    }
    return pageIndex !== stepIndex;
  }

  haveToHideSectionDuplicable(): boolean {
    let pageIndex = Number(this.indexPage?.toString().split('.')[0]);
    return !this.eformDuplicableEntityService.isSectionDuplicableStep(pageIndex);
  }

  ngOnInit(): void {
    // ✅ SUPPRESSION: L'appel setReloadingDuplicableElement(true) sans type est supprimé
    // Seuls les composants duplicable-element.component.ts doivent gérer le rechargement avec le type correct
    this.cd.detectChanges();
    this.stepperBuilderService.duplicableSection.pipe(takeUntil(this.unsubscribe$)).subscribe(duplicableSection => {
      this.duplicableSectionClean = JSON.parse(JSON.stringify(duplicableSection))
      this.duplicableSection = JSON.parse(JSON.stringify(duplicableSection))
    })
    this.eformDuplicableEntityService.typeAnnForDuplicableSection.pipe(takeUntil(this.unsubscribe$)).subscribe(typeAnnForDuplicableSection => {
      if (typeAnnForDuplicableSection) {
        this.eformDuplicableEntityService.isEformDuplicableEntityReady.next(true);
        // Forcer un cycle de détection de changement après l'arrivée des données
        // réelles du lot. Sans cela, les FormControl sont bien alimentés avec les bonnes valeurs
        // (vérifié : BT-131(t)-Lot reçoit "14:30:00"), mais Angular ne repropage jamais ces valeurs
        // vers le DOM : l'<input type="time"> reste visuellement vide.
        // Symptôme historique : l'heure limite de remise des offres ne s'affichait pas, alors que
        // la donnée était correcte du backend jusqu'au FormControl. Le bug disparaissait en mode
        // debugger, car les pauses provoquaient des cycles de détection supplémentaires.
        // Le setTimeout garantit que la mise à jour du DOM intervient après la reconstruction
        // complète des contrôles par la factory, sur le tick suivant.
        setTimeout(() => {
          this.cd.detectChanges();
        }, 0);
      }
    })
    //Modification de la structure du formulaire
    this.stepperBuilderService.notice.pipe(takeUntil(this.unsubscribe$)).subscribe(notice => {
      if (notice) {
        if (this.canNavigateInStepperService.eformCreatingChange && (notice.sections.map(e => e.baseId).includes('GR-Lot') || notice.sections.map(e => e.baseId).includes('GR-Part'))) {
          this.eformDuplicableEntityService.listDuplicableEntity.pipe(first(list => list != null && list.length > 0)).subscribe(() => {
            this.extractDuplicableSectionIfNeeded(notice);
            this.cd.detectChanges();
            this.eformDuplicableEntityService.isEformDuplicableEntityReady.next(true);
            this.cd.detectChanges();
            setTimeout(() => {
              this.eformDuplicableEntityService.duplicableSectionChargeEnded.next(true);
            }, 0);
          })
        } else {
          this.extractDuplicableSectionIfNeeded(notice);
          this.cd.detectChanges();
        }
        //Récupération des données d'un lot
        this.eformDuplicableEntityService.currentDuplicableSectionValue.pipe(takeUntil(this.unsubscribeCurrentDuplicableSectionValue$)).subscribe(currentduplicableSectionValue => {
          if (currentduplicableSectionValue) {
            this.eformDuplicableEntityService.isEformDuplicableEntityReady.next(false);
            this.eformConditionsService.clearExistingItemsForLot();
            this.duplicableSection = JSON.parse(JSON.stringify(this.duplicableSectionClean))
            //On met les données dans un avis pour ne pas avoir à adapter la mécanique d'extraction des données à partir du jsonPath
            const firstItemName = ENoticeTypeXsd[this.stepperBuilderService.formulaire];
            this.duplicableSectionValue = new TypeAnn();
            if ('priorInformationNotice' === firstItemName) {
              this.duplicableSectionValue.priorInformationNotice = new PriorInformationNotice();
            } else if ('contractNotice' === firstItemName) {
              this.duplicableSectionValue.contractNotice = new ContractNotice();
            } else if ('contractAwardNotice' === firstItemName) {
              this.duplicableSectionValue.contractAwardNotice = new ContractAwardNotice();
            } else if ('businessRegistrationInformationNotice' === firstItemName) {
              this.duplicableSectionValue.businessRegistrationInformationNotice = new BusinessRegistrationInformationNotice();
            }
            this.duplicableSectionValue[firstItemName].procurementProjectLot = [];
            this.duplicableSectionValue[firstItemName].procurementProjectLot.push(currentduplicableSectionValue);
            this.duplicableSectionValue = this.eformsToolsService.propertyNamesToLowercase(this.duplicableSectionValue);
            this.eformDuplicableEntityService.typeAnnForDuplicableSection.next(this.duplicableSectionValue)
          }
        });
        setTimeout(() => {
          if (this.linkForRouter?.includes('creerAvisPub') && this.eformDuplicableEntityService.initialSectionDuplicableIndex !== -1) {
            this.eformDuplicableEntityService.isEformDuplicableEntityReady.next(true);
          }
          if (this.canNavigateInStepperService.avisIdParent) {
            this.eformDuplicableEntityService.isEformDuplicableEntityReady.next(true);
            if (this.eformDuplicableEntityService.firstSaveIsEndedForAvisLie.getValue() === true) {
              const avis: Avis = this.prepareAvisBody(this.formGroup);
              this.eformDuplicableEntityService.createAvisLie(avis, this.stepperBuilderService.avisId, this.canNavigateInStepperService.avisIdParent, this.canNavigateInStepperService.avisLieModalite).subscribe(() => {
                this.eformDuplicableEntityService.duplicableSectionAvisLieIsCreated.next(true);
                this.eformDuplicableEntityService.isEformDuplicableEntityReady.next(true);
                this.eformDuplicableEntityService.getAvisWithAllDuplicablesElements(this.stepperBuilderService.avisId).subscribe(() =>
                  this.eformDuplicableEntityService.isAvisWithAllDuplicablesElementsReady.next(true));
              })
            } else {
              this.eformDuplicableEntityService.firstSaveIsEndedForAvisLie.pipe(first(isEnded => isEnded === true)).subscribe(() => {
                const avis: Avis = this.prepareAvisBody(this.formGroup);
                this.eformDuplicableEntityService.createAvisLie(avis, this.stepperBuilderService.avisId, this.canNavigateInStepperService.avisIdParent, this.canNavigateInStepperService.avisLieModalite).subscribe(() => {
                  this.eformDuplicableEntityService.duplicableSectionAvisLieIsCreated.next(true);
                  this.eformDuplicableEntityService.isEformDuplicableEntityReady.next(true);
                  this.eformDuplicableEntityService.getAvisWithAllDuplicablesElements(this.stepperBuilderService.avisId).subscribe(() => {
                    this.eformDuplicableEntityService.isAvisWithAllDuplicablesElementsReady.next(true);
                  });
                })
              })
            }
          }
          if (this.eformDuplicableEntityService.missDuplicableSectionInit) {
            this.eformDuplicableEntityService.isEformDuplicableEntityReady.next(true);
            this.cd.detectChanges()
            this.eformDuplicableEntityService.duplicableSectionChargeEnded.next(true);
          }

          if (this.canNavigateInStepperService.currentFormulaire.includes('E_FORM')) {
            // Dans le cas d'un E-FORM attente du chargement de l'élément duplicable pour lancer la moulinette de sauvegarde
            this.eformDuplicableEntityService.isDataDuplicableEntityReady.pipe(first((bool) => bool === true)).subscribe(() => {
              this.cd.detectChanges();
              // ✅ SUPPRESSION: L'appel setReloadingDuplicableElement(false) est géré par duplicable-element.component.ts
              this.cd.detectChanges();
              this.executeOnReloadingEnd();

              // 🔧 FIX 2026-01-22: Forcer un rescan des flatFields après que les données duplicables soient prêtes
              // Cela garantit que les valeurs de tous les lots sont dans flatFields pour l'évaluation des conditions
              if (this.formGroup) {
                this.eformConditionsServiceV2.rescanFlatFieldsFromForm(this.formGroup);
              }
            })
          } else {
            // ✅ SUPPRESSION: L'appel setReloadingDuplicableElement(false) est géré par duplicable-element.component.ts
            this.cd.detectChanges();
            this.executeOnReloadingEnd();
          }
          // Permet de recuperer en live les valeurs des champs de la section pour appliquer les conditions
          if (this.formGroup) {
            // ✅ Définir le nom du formulaire courant AVANT d'initialiser l'observation
            // Cela garantit que setCurrentFormName est appelé avant que cleanupForbiddenFieldsWithConditions
            // ne tente de charger les métadonnées et les forbiddenConditionV2
            this.eformConditionsServiceV2.setCurrentFormName(this.stepperBuilderService.formulaire.toString());

            this.eformConditionsServiceV2.resetFlatFields();
            this.eformConditionsServiceV2.initializeFormObservation(this.formGroup);
            DuplicableElementPathEnum.initializePaths(ENoticeTypeXsd[this.stepperBuilderService.formulaire].toLowerCase());
          }
          this.spinner.hide();
        });
      }
    });

    //Récupération des données d'un avis
    this.currentJson.pipe(takeUntil(this.unsubscribe$)).subscribe((noticeValue: Avis) => {
      this.noticeTypeBh.pipe(takeUntil(this.unsubscribe$)).subscribe(noticeType => {
        if (noticeType) {
          this.noticeValue = null;
          this.getJsonForm(noticeType, noticeValue);
        }
      });
    });
    //Récupération du booleen pour l'activation des sections duplicable
    this.eformDuplicableEntityService.isEformDuplicableEntityReady.pipe(takeUntil(this.unsubscribe$)).subscribe(isReady => {
      this.isDuplicableSectionReady = isReady;
      this.canNavigateInStepperService.eformAllInputCreated = false;
      this.cd.detectChanges();
      if (this.isDuplicableSectionReady === true) {
        // ✅ SUPPRESSION: L'appel setReloadingDuplicableElement(false) est géré par duplicable-element.component.ts
        this.cd.detectChanges();
        this.executeOnReloadingEndForSection();
      }
    });

    if (this.linkForRouter?.includes('editerAvisPub') && this.eformDuplicableEntityService.currentDuplicableSectionValue.getValue()) {
      this.eformDuplicableEntityService.currentDuplicableSectionValue.next(this.eformDuplicableEntityService.currentDuplicableSectionValue.getValue());
    }

    // Observable pour détecter le passage à false de isCreationButBeforeFirstSave
    this.eformDuplicableEntityService.isCreationButBeforeFirstSave
      .pipe(
        takeUntil(this.unsubscribe$),
        pairwise(),
        filter(([prev, curr]) => prev === true && curr === false),
        take(1),
        defaultIfEmpty(null)
      )
      .subscribe((result) => {
        if (result !== null) {
          // ✅ SUPPRESSION: L'appel setReloadingDuplicableElement(false) est géré par duplicable-element.component.ts
          this.cd.detectChanges();
        }
      });
  }

  private extractDuplicableSectionIfNeeded(notice) {
    //On récupère la section duplicable si elle existe
    let duplicableSections = notice.sections.filter(section => 'GR-Lot' === section.baseId || 'GR-Part' === section.baseId);
    if (duplicableSections.length > 0) {
      this.stepperBuilderService.duplicableSection.next(duplicableSections[0]);
    }
    //On le retire des sections
    this.notice = notice;
    this.notice.sections = notice.sections.filter(section => 'GR-Lot' !== section.baseId && 'GR-Part' !== section.baseId);

    this.eformDuplicableEntityService.extractDuplicableElementIfNeeded(notice);
  }


  private getJsonForm(noticeType: NoticeTypesEnum, noticeValue) {
    // le type de la notice est en dur temporairement
    this.canNavigateInStepperService.eformAllInputCreated = false;
    this.httpClient
      .get('assets/dynamic/creer/formSections/' + noticeType + '.json', null, {basePath: ''})
      .pipe(take(1))
      .subscribe((data) => {
        // suite à la récupération du formulaire on récupere la valeur
        let tempNotice = EFormsSdkService.getNotice(noticeType, data, this.eFormsOrgService);
        this.eformInfoService.dataToMap(data);
        for (let index = 0; index < tempNotice.sections.length; index++) {
          if (tempNotice.sections[index].id.includes('LotsGroup') || (tempNotice.sections[index].id.includes('Change') && !this.canNavigateInStepperService.eformMotifChange)) {
            let removedStepIndex = 0;
            tempNotice.sections.splice(index, 1);
            removedStepIndex = index + 1;
            tempNotice.sections.forEach(step => {
              if (step.index > removedStepIndex) {
                step.index--;
              }
            });
            index--;
          }
        }


        if (this.eformPrefillService.tempNotice?.refAvisLie && !(this.eformPrefillService.tempNotice?.jsonSaisieFormulaire?.ann?.priorInformationNotice
          || this.eformPrefillService.tempNotice?.jsonSaisieFormulaire?.ann?.contractAwardNotice
          || this.eformPrefillService.tempNotice?.jsonSaisieFormulaire?.ann?.contractNotice
          || this.eformPrefillService.tempNotice?.jsonSaisieFormulaire?.ann?.businessRegistrationInformationNotice)) {
          this.eformPrefillService.isPrefillAvisLie = true;
        }

        if (!noticeValue && this.eformPrefillService.tempNotice) {
          noticeValue = this.eformPrefillService.tempNotice;
        }

        if (noticeValue?.jsonSaisieFormulaire?.ann?.priorInformationNotice || noticeValue?.jsonSaisieFormulaire?.ann?.contractAwardNotice || noticeValue?.jsonSaisieFormulaire?.ann?.contractNotice || noticeValue?.jsonSaisieFormulaire?.ann?.businessRegistrationInformationNotice) {
          // ✅ FIX 2026-04-14: Extraire les prefillValues et mettre à jour dataTransferService.avis
          // pour le chemin "édition" (noticeValue déjà présent), afin que form-input puisse lire prefillValues
          this.extractAndStorePrefillValues(noticeValue);
          this.dataTransferService.avis = noticeValue;

          this.noticeValue = this.eformsToolsService.propertyNamesToLowercase(noticeValue?.jsonSaisieFormulaire?.ann);

          // ✅ FIX 2026-03-10: La création des structures manquantes est désormais gérée
          // de manière générique dans InputIdEnrichmentService.createMissingStructuresForChangeNotice
          // appelé dans ImportAvisService.importAndEnrich

          // 🔧 FIX 2026-01-22: Remplir avisWithElementsDuplicable avec les données de l'avis
          // pour que les conditions puissent fonctionner immédiatement sur tous les lots.
          if (noticeValue?.jsonSaisieFormulaire) {
            const avisData = this.eformsToolsService.propertyNamesToLowercase({
              jsonsaisieformulaire: noticeValue.jsonSaisieFormulaire
            });
            this.eformDuplicableEntityService.avisWithElementsDuplicable.next(avisData);
          }

          this.eformsSubjectService.notice = tempNotice;
          this.canNavigateInStepperService.currentFormulaire = noticeType.toString();
          if (this.eformPrefillService.isPrefillAvisLie) {
            this.eformPrefillService.noticeCompleted.pipe(first(newNotice => newNotice != null)).subscribe(newNotice => {
              newNotice = this.setIdAnnEmetteurAndContractfolderid(newNotice);
              this.noticeValue = newNotice;
              this.eformsSubjectService.notice = tempNotice;
              this.stepperBuilderService.notice.next(tempNotice);
              this.cd.detectChanges();
              this.stepperBuilderService.prefillDone.next(true);

              // ✅ FIX 2026-02-19: Attendre que le formulaire soit prêt avant de désactiver isLoadingAvisLie
              this.eformDuplicableEntityService.isFormReady
                .pipe(first(ready => ready === true), takeUntil(this.unsubscribe$))
                .subscribe(() => {
                  this.eformConditionsServiceV2.setLoadingAvisLie(false);
                });
            });
          } else {
            this.stepperBuilderService.notice.next(tempNotice);
          }
        } else if (!this.linkForRouter?.includes('visualiser')) {
          this.spinner.show();
          this.httpClient.post("/avis/prefillEforms", this.newAvisClean(), Avis).subscribe(value => {
            this.spinner.hide();
            if (value.refConsultation?.toString()) {
              sessionStorage.setItem('refConsultation', value.refConsultation.toString());
            }
            this.nextToPrefillActions(tempNotice, noticeType, value);
          });
        } else {
          this.stepperBuilderService.notice.next(tempNotice);
        }
      });
  }

  /**
   * Supprime-les elements duplicable de la noticeValue pour éviter que l'objet initial ne soit rempli (il servira plus tard pour l'ajout)
   * @param noticeValue
   * @param firstItemName
   * @private
   */
  private clearDuplicableObjetFromNoticeValue(noticeValue, firstItemName: string) {
    Object.entries(DuplicableElementPartialPathsEnum).forEach(([key, value]) => {
      if (sessionStorage.getItem(key) && noticeValue[firstItemName]) {
        noticeValue[firstItemName] = this.eformDataService.clearArrayAtPath(noticeValue[firstItemName], value, false);
      }
    });
    return noticeValue;
  }

  /**
   * Récupére le préremplissage place pour le stocker dans le session storage jusqu'a la sauvegarde en base
   * @param firstItemName
   * @private
   */
  private putDuplicableEntitiesInLocalStorage(firstItemName: string) {
    if (this.noticeValue && this.noticeValue[firstItemName]) {
      Object.entries(DuplicableElementPartialPathsEnum).forEach(([key, value]) => {
        let duplicableObjets = this.eformDataService.getFormArrayFromNoticeValue(value, this.noticeValue[firstItemName]);
        if (duplicableObjets) {
          sessionStorage.setItem(key, JSON.stringify(duplicableObjets));
        }
      });
    }
  }

  /**
   * Extrait les valeurs de préremplissage depuis le JSON de l'avis et les stocke dans
   * value.jsonSaisieFormulaire.prefillValues (Map<String,String> côté backend)
   * ET dans le sessionStorage pour la lecture immédiate par form-input.component.
   */
  private extractAndStorePrefillValues(value: any): void {
    if (!value?.jsonSaisieFormulaire) {
      return;
    }
    if (!value.jsonSaisieFormulaire.prefillValues) {
      value.jsonSaisieFormulaire.prefillValues = {};
    }
    this.extractPrefillStreetName(value);
    this.extractPrefillDocumentUrl(value);
    this.extractPrefillSubmissionUrl(value);
  }

  /**
   * Extrait le streetName (BT-5101(a)-Procedure) depuis le JSON et le stocke dans prefillValues ET sessionStorage.
   * Cherche en PascalCase et lowercase pour couvrir tous les chemins (création/édition).
   */
  private extractPrefillStreetName(value: any): void {
    const noticeTypesPascal = ['contractAwardNotice', 'contractNotice', 'businessRegistrationInformationNotice', 'priorInformationNotice'];
    const noticeTypesLower = ['contractawardnotice', 'contractnotice', 'businessregistrationinformationnotice', 'priorinformationnotice'];
    const allTypes = [...noticeTypesPascal, ...noticeTypesLower];
    for (const type of allTypes) {
      const streetName = value?.jsonSaisieFormulaire?.ann?.[type]?.procurementProject?.realizedLocation?.[0]?.address?.streetName?.val;
      if (streetName != null) {
        value.jsonSaisieFormulaire.prefillValues['prefill_streetName'] = streetName;
        value.jsonSaisieFormulaire.ann[type].procurementProject.realizedLocation[0].address.streetName.val = null;
        return;
      }
    }
  }

  /**
   * Extrait l'URL du document (BT-15-Lot) depuis le JSON et la stocke dans prefillValues ET sessionStorage.
   * Cherche en PascalCase et lowercase pour couvrir tous les chemins (création/édition).
   */
  private extractPrefillDocumentUrl(value: any): void {
    const noticeTypesPascal = ['contractAwardNotice', 'contractNotice', 'businessRegistrationInformationNotice', 'priorInformationNotice'];
    const noticeTypesLower = ['contractawardnotice', 'contractnotice', 'businessregistrationinformationnotice', 'priorinformationnotice'];
    const allTypes = [...noticeTypesPascal, ...noticeTypesLower];
    for (const type of allTypes) {
      const lots = value?.jsonSaisieFormulaire?.ann?.[type]?.procurementProjectLot;
      if (Array.isArray(lots)) {
        for (let i = 0; i < lots.length; i++) {
          const refs = lots[i]?.tenderingTerms?.callForTendersDocumentReference;
          if (Array.isArray(refs)) {
            for (let j = 0; j < refs.length; j++) {
              const uri = refs[j]?.attachment?.externalReference?.uri?.val;
              if (uri != null) {
                value.jsonSaisieFormulaire.prefillValues['prefill_documentUrl'] = uri;
                value.jsonSaisieFormulaire.ann[type].procurementProjectLot[i].tenderingTerms.callForTendersDocumentReference[j].attachment.externalReference.uri.val = null;
                return;
              }
            }
          }
        }
      }
    }
  }

  /**
   * Extrait l'URL de soumission (BT-18-Lot) depuis le JSON et la stocke dans prefillValues ET sessionStorage.
   * Cherche en PascalCase et lowercase pour couvrir tous les chemins (création/édition).
   */
  private extractPrefillSubmissionUrl(value: any): void {
    const noticeTypesPascal = ['contractAwardNotice', 'contractNotice', 'businessRegistrationInformationNotice', 'priorInformationNotice'];
    const noticeTypesLower = ['contractawardnotice', 'contractnotice', 'businessregistrationinformationnotice', 'priorinformationnotice'];
    const allTypes = [...noticeTypesPascal, ...noticeTypesLower];
    for (const type of allTypes) {
      const lots = value?.jsonSaisieFormulaire?.ann?.[type]?.procurementProjectLot;
      if (Array.isArray(lots)) {
        for (let i = 0; i < lots.length; i++) {
          const endpointId = lots[i]?.tenderingTerms?.tenderRecipientParty?.endpointID?.val;
          if (endpointId != null) {
            value.jsonSaisieFormulaire.prefillValues['prefill_submissionUrl'] = endpointId;
            value.jsonSaisieFormulaire.ann[type].procurementProjectLot[i].tenderingTerms.tenderRecipientParty.endpointID.val = null;
            return;
          }
        }
      }
    }
  }

  private nextToPrefillActions(tempNotice, noticeType, value) {
    this.eformsSubjectService.notice = tempNotice;
    this.canNavigateInStepperService.currentFormulaire = noticeType.toString();
    if (value?.jsonSaisieFormulaire && !this.linkForRouter?.includes('editerAvisPub')) {
      // ✅ FIX 2026-04-14: Extraire les valeurs de préremplissage depuis le JSON et les stocker
      // dans prefillValues pour qu'elles soient accessibles par form-input sans passer par sessionStorage
      this.extractAndStorePrefillValues(value);

      this.noticeValue = this.eformsToolsService.propertyNamesToLowercase(value.jsonSaisieFormulaire.ann);

      // ✅ FIX 2026-04-08: Mettre à jour avisDataTransferService.avis avec la réponse du prefill
      // pour que IndexationService puisse lire les valeurs via avis.jsonSaisieFormulaire.ann.indexation
      this.dataTransferService.avis = value;

      // ✅ FIX 2026-04-08: Émettre prefillDone AVANT notice.next() pour que le stepper mette à jour
      // this.indexation avant que Angular rende <app-type-indexation>
      this.stepperBuilderService.prefillDone.next(true);

      // 🔧 FIX 2026-01-22: Remplir avisWithElementsDuplicable avec les données de préremplissage
      // pour que les conditions puissent fonctionner immédiatement sur tous les lots.
      if (value.jsonSaisieFormulaire) {
        const avisData = this.eformsToolsService.propertyNamesToLowercase({
          jsonsaisieformulaire: value.jsonSaisieFormulaire
        });
        this.eformDuplicableEntityService.avisWithElementsDuplicable.next(avisData);
        // Pré-remplir le cache 'time' (FormInputFactory.timeFieldValueCache)
        // depuis ces mêmes données complètes de préremplissage, disponibles ici bien avant que
        // le circuit par-lot (asynchrone) n'alimente réellement le champ affiché. Cf. commentaire
        // sur FormInputFactory.prefillTimeFieldCache pour le contexte complet.
        this.prefillDlroTimeCache(avisData);
      }

      if (noticeType.includes('E_FORM')) {
        const firstItemName = ENoticeTypeXsd[this.stepperBuilderService.formulaire].toLowerCase();
        this.putDuplicableEntitiesInLocalStorage(firstItemName);

        this.noticeValue = this.clearDuplicableObjetFromNoticeValue(this.noticeValue, firstItemName);
      }
      this.eformsSubjectService.notice = tempNotice;
      this.stepperBuilderService.notice.next(tempNotice);
      this.cd.detectChanges();
      this.dataTransferService.sourceAppProfilAcheteurInfos = value.jsonSaisieFormulaire.sourceAppProfilAcheteurInfos;
    } else {
      if (this.eformPrefillService.isPrefillAvisLie) {
        this.eformPrefillService.prefillAvisLieEform(1, this.eformPrefillService.codeOrigine, this.eformPrefillService.tempNotice.formulaire.code, this.eformPrefillService.tempNotice.refAvisLie, this.eformPrefillService.tempNotice.jsonSaisieFormulaire.ann);
        this.eformPrefillService.noticeCompleted.pipe(first(newNotice => newNotice != null)).subscribe(newNotice => {
          newNotice = this.setIdAnnEmetteurAndContractfolderid(newNotice);
          this.noticeValue = newNotice;
          this.eformsSubjectService.notice = tempNotice;
          this.stepperBuilderService.notice.next(tempNotice);
          this.cd.detectChanges();
          this.stepperBuilderService.prefillDone.next(true);

          // ✅ FIX 2026-02-19: Attendre que le formulaire soit prêt avant de désactiver isLoadingAvisLie
          this.eformDuplicableEntityService.isFormReady
            .pipe(first(ready => ready === true), takeUntil(this.unsubscribe$))
            .subscribe(() => {
              this.eformConditionsServiceV2.setLoadingAvisLie(false);
            });
        });
      } else {
        if (this.eformPrefillService.tempNotice != null && !this.eformPrefillService.tempNotice.refAvisLie) {
          this.eformPrefillService.noticeCompleted.pipe(first(newNotice => newNotice != null)).subscribe(newNotice => {
            this.noticeValue = newNotice;
            this.eformsSubjectService.notice = tempNotice;
            this.stepperBuilderService.notice.next(tempNotice);
            this.cd.detectChanges();
            this.stepperBuilderService.prefillDone.next(true);
          });
        } else {
          this.stepperBuilderService.notice.next(tempNotice);
        }
      }
    }
  }

  /**
   * Pré-remplit FormInputFactory.timeFieldValueCache avec l'heure de la DLRO
   * (BT-131(t)-Lot, tenderSubmissionDeadlinePeriod.endTime) de chaque lot, à partir des données
   * complètes de préremplissage — avant même que l'onglet du lot concerné ne soit affiché et que
   * le circuit par-lot (asynchrone, plus lent) n'ait eu l'occasion de renvoyer sa propre valeur.
   *
   * Volontairement limité à ce seul champ pour l'instant (cf. discussion) : c'est le cas concret
   * identifié, une généralisation à d'autres champs 'time' nécessiterait de reproduire ce même
   * pré-remplissage pour chacun, ce qui n'est pas fait ici.
   */
  private prefillDlroTimeCache(avisData: any): void {
    const ann = avisData?.jsonsaisieformulaire?.ann;
    if (!ann) {
      return;
    }
    const formKey = Object.keys(ann).find(key =>
      key.includes('notice') && typeof ann[key] === 'object' && ann[key] !== null
    );
    if (!formKey) {
      return;
    }
    const lots = ann[formKey]?.procurementprojectlot;
    if (!Array.isArray(lots)) {
      return;
    }
    lots.forEach((lot, index) => {
      let endTimeVal = lot?.tenderingprocess?.tendersubmissiondeadlineperiod?.endtime?.val;
      // Même troncature que celle appliquée dans FormInputFactory (ligne ~188) pour un champ
      // 'time' : la donnée brute est une chaîne ISO complète, l'input HTML n'accepte que HH:mm:ss.
      if (endTimeVal?.length > 10) {
        endTimeVal = endTimeVal.substring(11, 19);
      }
      if (endTimeVal) {
        // Format de clé aligné sur celui utilisé côté lecture dans
        // FormInputFactory (index de lot réel extrait de prefixId, pas repeatablePathWithIndex
        // qui est toujours à 0). Ici, l'index de position dans le tableau du préremplissage
        // correspond bien à actuaEntityIndex (cf. EformDuplicableEntityService.getDuplicableEntity :
        // actuaEntityIndex = index - 1, où index est le numéro de lot 1-based demandé par l'onglet).
        const cacheKey = `${index}_SEPSEP_BT-131(t)-Lot`;
        FormInputFactory.prefillTimeFieldCache(cacheKey, endTimeVal);
      }
    });
  }

  private setIdAnnEmetteurAndContractfolderid(newNotice: any) {
    if (ENoticeTypeXsd[this.stepperBuilderService.formulaire] == 'contractNotice') {
      newNotice.contractnotice.id = {};
      newNotice.contractnotice.id.val = this.formulaireService.actualFormIdAnnEmetteur.getValue();
      newNotice.contractnotice.contractfolderid = {};
      newNotice.contractnotice.contractfolderid.val = this.formulaireService.actualFormContractFolderId.getValue();
      if (!newNotice.contractnotice?.tenderingprocess) {
        newNotice.contractnotice.tenderingprocess = {};
      }
      newNotice.contractnotice.tenderingprocess.noticedocumentreference = [];
      newNotice.contractnotice.tenderingprocess.noticedocumentreference.push({})
      newNotice.contractnotice.tenderingprocess.noticedocumentreference[0].id = {};
      newNotice.contractnotice.tenderingprocess.noticedocumentreference[0].id.val = this.formulaireService.idParentFluxBoampEform.getValue();
    } else if (ENoticeTypeXsd[this.stepperBuilderService.formulaire] == 'priorInformationNotice') {
      newNotice.priorinformationnotice.id = {};
      newNotice.priorinformationnotice.id.val = this.formulaireService.actualFormIdAnnEmetteur.getValue();
      newNotice.priorinformationnotice.contractfolderid = {};
      newNotice.priorinformationnotice.contractfolderid.val = this.formulaireService.actualFormContractFolderId.getValue();
      if (!newNotice.priorinformationnotice?.tenderingprocess) {
        newNotice.priorinformationnotice.tenderingprocess = {};
      }
      newNotice.priorinformationnotice.tenderingprocess.noticedocumentreference = [];
      newNotice.priorinformationnotice.tenderingprocess.noticedocumentreference.push({})
      newNotice.priorinformationnotice.tenderingprocess.noticedocumentreference[0].id = {};
      newNotice.priorinformationnotice.tenderingprocess.noticedocumentreference[0].id.val = this.formulaireService.idParentFluxBoampEform.getValue();
    } else if (ENoticeTypeXsd[this.stepperBuilderService.formulaire] == 'contractAwardNotice') {
      newNotice.contractawardnotice.id = {};
      newNotice.contractawardnotice.id.val = this.formulaireService.actualFormIdAnnEmetteur.getValue();
      newNotice.contractawardnotice.contractfolderid = {};
      newNotice.contractawardnotice.contractfolderid.val = this.formulaireService.actualFormContractFolderId.getValue();
      if (!newNotice.contractawardnotice?.tenderingprocess) {
        newNotice.contractawardnotice.tenderingprocess = {};
      }
      newNotice.contractawardnotice.tenderingprocess.noticedocumentreference = [];
      newNotice.contractawardnotice.tenderingprocess.noticedocumentreference.push({})
      newNotice.contractawardnotice.tenderingprocess.noticedocumentreference[0].id = {};
      newNotice.contractawardnotice.tenderingprocess.noticedocumentreference[0].id.val = this.formulaireService.idParentFluxBoampEform.getValue();
    } else if (ENoticeTypeXsd[this.stepperBuilderService.formulaire] == 'businessRegistrationInformationNotice') {
      newNotice.businessregistrationinformationnotice.id = {};
      newNotice.businessregistrationinformationnotice.id.val = this.formulaireService.actualFormIdAnnEmetteur.getValue();
    }
    return newNotice;
  }

  getStepId() {
    let stepId = this.notice?.sections[(this.indexPage - 1).toString().split('.')[0]]?.id;

    if (this.eformDuplicableEntityService.getSectionDuplicableIndexes().includes(Number(this.indexPage.toString().split('.')[0]))) {
      let actualLot = this.eformDuplicableEntityService.currentDuplicableSectionValue.getValue() as unknown as ProcurementProjectLotType;
      stepId = actualLot?.id?.val?.includes('PAR') ? 'GR-Part' : 'GR-Lot';
      if (Number(this.indexPage.toString().split('.')[0]) > this.indexFirstDuplicableSection) {
        stepId += '_' + (Number(this.indexPage.toString().split('.')[0]) - this.indexFirstDuplicableSection);
      }
    }
    if (this.eformDuplicableEntityService.getSectionDuplicableIndexes().length > 0 && Number(this.indexPage.toString().split('.')[0]) > this.eformDuplicableEntityService.getSectionDuplicableIndexes()[this.eformDuplicableEntityService.getSectionDuplicableIndexes().length - 1]) {
      stepId = this.notice?.sections[(this.indexPage - 1 - this.eformDuplicableEntityService.getSectionDuplicableIndexes().length).toString().split('.')[0]]?.id
      if (this.notice && this.notice.sections[(this.indexPage - 1 - this.eformDuplicableEntityService.getSectionDuplicableIndexes().length)]?.index) {
        this.notice.sections[(this.indexPage - 1 - this.eformDuplicableEntityService.getSectionDuplicableIndexes().length)].index = this.indexPage
      }
    }
    if (stepId) {
      if (stepId.includes('_')) {
        stepId += this.indexPage.toString().includes('.') ? '_' + (+this.indexPage.toString().split('.')[1] - 1) : '_0';
      } else {
        stepId += '_0_';
        stepId += this.indexPage.toString().includes('.') ? +this.indexPage.toString().split('.')[1] - 1 : '0';
      }
    }
    if (Number(this.indexPage.toString().split('.')[0]) === this.validationIndex) {
      stepId = "Validation_" + this.validationIndex + "_" + this.indexPage.toString().split('.')[1];
    }
    return stepId;
  }

  getRepeatablePathWithIndexForSection = (section): string => {
    if (section?.jsonPath) {
      return section.jsonPath + '_INDEX_' + (this.getArray(section));
    }
  }


  getRepeatablePathWithIndexForInput = (): string => {
    return;
  }

  getRepeatablePathForDuplicableElement = (): string => {
    return;
  }

  findArrayByPath(jsonPath, noticeValue ?) {
    let tempControl;
    let i = 0;
    let pathElements = jsonPath.split('.');
    pathElements.pop();

    pathElements.forEach(elements => {
      if (!noticeValue) {
        if (i == 0) {
          tempControl = elements.includes('[]') ? (<any>this.formGroup).controls[elements.replace('[]', '')].controls[0]
            : this.formGroup.controls[elements];
        } else {
          if (elements.includes('[]')) {
            if (i == pathElements.length - 1) {
              tempControl = tempControl?.controls[elements.replace('[]', '')]
            } else {
              tempControl = tempControl?.controls[elements.replace('[]', '')]?.controls[this.eformDataService.getArrayIndex(elements, jsonPath)];
            }
          } else {
            tempControl = tempControl?.controls[elements];
          }
        }
        i++;
      } else {
        if (i == 0) {
          tempControl = noticeValue[elements.replace('[]', '')];
        } else {
          if (elements.includes('[]')) {
            if (i == pathElements.length - 1) {
              tempControl = tempControl[elements.replace('[]', '')]
            } else {
              tempControl = tempControl[elements.replace('[]', '')][this.eformDataService.getArrayIndex(elements, jsonPath)];
            }
          } else {
            tempControl = tempControl[elements];
          }
        }
        i++;
      }
    });
    return tempControl;
  }

  getArray(actual) {
    let tempControl = this.findArrayByPath(actual.jsonPath);
    return tempControl?.controls?.length > 0 ? this.findIndexDependingOnId(actual, tempControl) : 0;
  }


  private findIndexDependingOnId(actual, tempControl) {
    //On cherche l'index du dernier element partageant le même baseId
    let previousId = actual.baseId;
    if (actual.id.includes('_') && +actual.id.split('_')[1] > 1) {
      previousId += '_' + (+actual.id.split('_')[1] - 1);
    }
    let previousIndex = +tempControl.controls.findIndex(c =>
      c.prefixEform === previousId);
    //Si on le trouve, on y ajoute 1 pour avoir notre index, sinon on recupére la longueur du tableau
    //(soit on l'ajoute à la suite d'un autre qui porte le mm baseId soit on le met à la fin)
    return previousIndex === -1 ? tempControl.controls.length : previousIndex + 1;
  }


  /**
   * Re-calculates the value and validation status of the entire controls tree.
   */
  updateTreeValidity(group: FormGroup | FormArray): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.controls[key];

      if (abstractControl instanceof FormGroup || abstractControl instanceof FormArray) {
        this.updateTreeValidity(abstractControl);
      } else {
        abstractControl.updateValueAndValidity();
      }
    });
  }

  newAvisClean() {
    const avis: Avis = new Avis();
    const annonce: Annonce = new Annonce();
    annonce.ann = new TypeAnn();
    annonce.ann.fnSimple = null;
    annonce.ann.divers = null;
    annonce.ann.mapa = null;
    // Facturation itself is initialized, but its field are left null in its constructor
    annonce.ann.facturation.libelle = new TypeAdresseTEMPOST();
    annonce.ann.facturation.libelle.classeProfit = new ClasseProfit();
    annonce.ann.idAnnEmetteur = null;

    if (ENoticeTypeXsd[this.stepperBuilderService.formulaire] == 'contractNotice') {
      annonce.ann.contractNotice = new ContractNotice();
    } else if (ENoticeTypeXsd[this.stepperBuilderService.formulaire] == 'priorInformationNotice') {
      annonce.ann.priorInformationNotice = new PriorInformationNotice();
    } else if (ENoticeTypeXsd[this.stepperBuilderService.formulaire] == 'contractAwardNotice') {
      annonce.ann.contractAwardNotice = new ContractAwardNotice();
    } else if (ENoticeTypeXsd[this.stepperBuilderService.formulaire] == 'businessRegistrationInformationNotice') {
      annonce.ann.businessRegistrationInformationNotice = new BusinessRegistrationInformationNotice();
    }

    avis.jsonSaisieFormulaire = annonce;
    avis.formulaire.code = FormsEnum[this.stepperBuilderService.formulaire];
    return avis;
  }

  private prepareAvisBody(form) {
    const avis: Avis = new Avis();
    const annonce: Annonce = new Annonce();
    annonce.ann = new TypeAnn();
    if (form?.controls?.priorinformationnotice !== undefined) {
      annonce.ann.priorInformationNotice = form?.controls?.priorinformationnotice.getRawValue();
    }
    if (form?.controls?.contractnotice !== undefined) {
      annonce.ann.contractNotice = form?.controls?.contractnotice.getRawValue();
    }
    if (form?.controls?.contractawardnotice !== undefined) {
      annonce.ann.contractAwardNotice = form?.controls?.contractawardnotice.getRawValue();
    }
    if (form?.controls?.businessregistrationinformationnotice !== undefined) {
      annonce.ann.businessRegistrationInformationNotice = form?.controls?.businessregistrationinformationnotice.getRawValue();
    }
    avis.jsonSaisieFormulaire = annonce;
    return avis;
  }


  /**
   * Exécute les actions à effectuer à la fin du rechargement d'un élément duplicable
   */
  private executeOnReloadingEnd(): void {
    this.canNavigateInStepperService.eformAllInputCreated = true;
    this.eformDuplicableEntityService.isFormReady.next(true);
    // ✅ FIX 2025-12-23: Suppression de l'appel getAvisWithAllDuplicablesElements
    // Cet appel est déjà fait dans useDataToUpdate (mode édition) ou avis-extractor.service (mode création)
    // L'appel ici était redondant et causait un doublon de requête get-avis

    // ✅ FIX 2026-04-27: Remplacer le timeout fixe de 2000ms par un délai dynamique
    // basé sur le nombre d'éléments duplicables. Sur Firefox avec 5+ lots,
    // 2000ms est insuffisant et cause le vidage prématuré de champs conditionnels
    // (BT-23-Lot, BT-24-Lot, BT-21-Lot, etc.) sur les lots 2-5.
    const elementCount = this.eformDuplicableEntityService.listDuplicableEntity.getValue()?.length || 0;
    // Base de 2000ms + 500ms par élément duplicable au-delà de 2, minimum 2000ms
    const dynamicDelay = Math.max(2000, 2000 + Math.max(0, elementCount - 2) * 500);
    setTimeout(() => {
      this.eformConditionsServiceV2.setLoadingAvisLie(false);
      // ✅ FIX 2026-03-05: Désactiver AUSSI isLoadingLot après le chargement complet
      this.eformConditionsServiceV2.setLoadingLot(false);
      // ✅ FIX 2026-03-05: Désactiver le flag pour TOUS les types d'éléments duplicables
      // Cela permet de réactiver les conditions pour BT-3202-Contract, BT-821-Lot, etc.
      this.eformDuplicableFieldsService.stopLoadingAllDuplicableElements();
    }, dynamicDelay);
  }

  /**
   * Exécute les actions spécifiques aux sections duplicables
   */
  private executeOnReloadingEndForSection(): void {
    this.canNavigateInStepperService.eformAllInputCreated = true;
  }
}
